/** @shared Used by Provider Search: components/app/ProviderSearch/FilterNudge. */

import { cn } from '@/lib/utils'
import { If } from '@/utility_components/ControlStatements'

interface ChipProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  label: string
  /** Decorative; the label provides the accessible name. */
  icon?: string
  endIcon?: React.ReactNode
  /** Omit for action chips that apply a filter immediately. */
  isSelected?: boolean
}

export function Chip({
  label,
  icon,
  endIcon,
  isSelected,
  disabled = false,
  className,
  type = 'button',
  ...props
}: ChipProps): React.ReactElement {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled}
      aria-pressed={isSelected}
      className={cn(
        '~m-0 ~inline-flex ~h-10 ~items-center ~gap-2 ~whitespace-nowrap ~rounded-full ~border ~border-solid ~border-grey ~bg-white ~px-4 ~py-0',
        '~font-gibson ~text-sm ~font-normal ~text-black',
        '~cursor-pointer ~transition-colors active:~bg-stepper-grey',
        'focus:~outline-none focus-visible:~border-sky focus-visible:~ring-1 focus-visible:~ring-inset focus-visible:~ring-sky',
        {
          '~border-[#398dd6] ~ring-1 ~ring-inset ~ring-[#398dd6]': !!isSelected,
        },
        'disabled:~cursor-not-allowed disabled:~border-grey-wash disabled:~bg-grey-wash disabled:~text-medium-grey disabled:~ring-0',
        className
      )}
    >
      <If condition={!!icon}>
        <img
          src={icon}
          alt=""
          aria-hidden="true"
          className={cn('~h-6 ~w-6 ~shrink-0', { '~opacity-50': disabled })}
        />
      </If>
      <span>{label}</span>
      <If condition={!!endIcon}>
        <span aria-hidden="true" className="~inline-flex ~shrink-0">
          {endIcon}
        </span>
      </If>
    </button>
  )
}

export default Chip
